import type * as React from 'react';
import { getFile } from '@Domain/Api';
import aiCostWorkbookExported, {
	type AiCostWorkbookExportedAction,
} from '@Application/AiCosts/Actions/aiCostWorkbookExported';
import aiCostWorkbookExportFailed, {
	type AiCostWorkbookExportFailedAction,
} from '@Application/AiCosts/Actions/aiCostWorkbookExportFailed';
import type ExportAiCostWorkbook from '@Application/AiCosts/Queries/ExportAiCostWorkbook';
import { downloadBlob } from '@Infra/Download';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AiCostWorkbookExportedAction | AiCostWorkbookExportFailedAction;

export default (query: ExportAiCostWorkbook) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${parameters.api.host}/api/accounts/${query.accountId}/ai-costs/export?${query.toQueryString()}`;

			const { blob, filename } = await getFile(url);
			downloadBlob(blob, filename ?? query.fallbackFilename);

			const action = aiCostWorkbookExported();
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostWorkbookExportFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
